$exso_logo_favicon $mol_object
